import { useDispatch } from "react-redux";
import { fetchThroughBrandAsync } from "../../features/listingPage/listingPageSlice";
import { useNavigate } from "react-router";
import { setSubCategories } from "../../features/listingPage/listingPageSlice";
import { setSelectedSubcategory } from "../../store/slices/subCategorySlice";
import { setBreadcrumb } from "../../store/slices/breadCrumbsSlice";
import Collections from "../../dComponent/Collections/Collections";
import ExclusiveBrand from "../../dComponent/Collections/ExclusiveBrand";
import Vocal4Local from "./Vocal4Local";

function OurBrands() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleFetchThroughBrands = (brand) => {
    dispatch(fetchThroughBrandAsync(brand)).then(() => {
      dispatch(setSubCategories([]));
      dispatch(setSelectedSubcategory(null));
      dispatch(
        setBreadcrumb({
          categoryID: null,
          categoryName: brand,
          subCategoryID: null,
          subCategoryName: "",
          productName: "",
          ProductID: null,
        })
      );
      navigate(`/listing-page/${brand}`);
    });
  };

  return (
    <div className="w-full flex flex-col pb-16 items-center bg-white-1 border border-gray-200">
      <ExclusiveBrand text="Exclusive Brands" align="center"/>
      <div className="w-full bg-gray-100">
        <Collections />
      </div>
      <Vocal4Local onBrandClick={handleFetchThroughBrands} />
    </div>
  );
}

export default OurBrands;
